import { storageUrl } from '../../../lib/api.js'
import { Badge, Modal } from '../../../components/ui/design.jsx'
import { kategoriColor, parseKat } from '../constants.js'
import StarRating from './StarRating.jsx'

export default function KelasPreviewModal({ item, onClose }) {
  if (!item) return null
  const kats = parseKat(item.kategori)

  return (
    <Modal onClose={onClose} title={item.title} wide>
      <div className="space-y-4">
        {item.image_url && (
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
            <img
              src={storageUrl(item.image_url)}
              alt={item.title}
              className="mx-auto max-h-[60vh] w-full object-contain"
              loading="lazy"
            />
          </div>
        )}

        <dl className="grid grid-cols-2 gap-3 text-sm">
          <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Kategori</dt>
          <dd className="flex flex-wrap gap-1">
            {kats.length > 0
              ? kats.map((k) => <Badge key={k} className={kategoriColor(k)}>{k}</Badge>)
              : <span className="text-gray-400">—</span>}
          </dd>

          <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Rating</dt>
          <dd className="flex items-center gap-1">
            <StarRating value={item.rating} readOnly />
            <span className="text-gray-900 text-sm">{item.rating}</span>
          </dd>

          <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Status</dt>
          <dd>{item.is_active ? <Badge variant="active">Aktif</Badge> : <Badge>Nonaktif</Badge>}</dd>

          {item.link_daftar && (
            <>
              <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Link Daftar</dt>
              <dd className="col-span-2 break-all text-xs font-mono text-blue-600">
                <a href={item.link_daftar} target="_blank" rel="noopener noreferrer">{item.link_daftar}</a>
              </dd>
            </>
          )}

          {item.deskripsi && (
            <>
              <dt className="text-xs font-semibold text-gray-400 uppercase tracking-wide col-span-2">Deskripsi</dt>
              <dd className="col-span-2 text-gray-900 text-sm leading-relaxed">{item.deskripsi}</dd>
            </>
          )}
        </dl>
      </div>
    </Modal>
  )
}
